import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	AIR_TIME_FAIRNESS_FOCUS_EVENT,
	AIR_TIME_FAIRNESS_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.atf_profiles']);

/**
 * Open the ATF accordion on the Templates page.
 * @return {Promise<void>} completion acknowledgement
 */
export function openAirTimeFairnessSection() {
	return openResourceSection(
		AIR_TIME_FAIRNESS_SECTION_EVENT,
		'profile.atf_profiles',
		SECTIONS,
	);
}

/**
 * Point at one ATF row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusAirTimeFairness(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_air_time_fairness_focus'));
	return dispatchAcknowledgedEvent(AIR_TIME_FAIRNESS_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'air_time_fairness',
	});
}
